import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSettingsStore } from '../stores/settingsStore'

const BottomFooter = () => {

    const { t } = useTranslation()
    const settings = useSettingsStore((state) => state.settings)

    return (
        <div className="py-8 bottom-footer bg-color-one">
            <div className="container container-lg">
                <div className="flex-wrap gap-16 py-16 bottom-footer__inner flex-between">
                    <p className="bottom-footer__text ">
                        {settings.store_name} © {new Date().getFullYear()}. {t('footer.allRightsReserved')}
                    </p>
                    <div className="flex-wrap gap-8 flex-align">
                        <span className="text-sm text-heading">{t('footer.weAreAccepting')}</span>
                        <div className="gap-8 flex-align">
                            <img src="assets/images/extra/mastercard.svg" alt="Mastercard" className='tw-h-8'/>
                            <img src="assets/images/extra/visa2.svg" alt="Visa" className='tw-h-8'/>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default BottomFooter